import { Expose } from "class-transformer";
import {
  IsBoolean,
  IsDateString,
  IsDefined,
  IsNumber,
  IsString,
} from "class-validator";

export class PushMessage {
  @Expose()
  @IsDefined()
  @IsNumber()
  id!: number;

  @Expose()
  @IsDefined()
  @IsString()
  title!: string;

  @Expose()
  @IsDefined()
  @IsString()
  body!: string;

  @Expose()
  @IsDefined()
  @IsBoolean()
  isSent!: boolean;

  @Expose()
  @IsDefined()
  @IsBoolean()
  immediate!: boolean;

  @Expose()
  @IsDefined()
  @IsDateString()
  sendDate!: string;

  @Expose()
  @IsDefined()
  @IsDateString()
  created!: string;

  @Expose()
  @IsDefined()
  @IsDateString()
  updated!: string;
}
